import { FloatingNode } from '@floating-ui/react';
import React from 'react';

import { useContextMenu } from '../hooks/use-context-menu';

type Props = {
  top: number;
  left: number;
  children: React.ReactNode;
  onClose?: () => void;
};

const RootMenu = (props: Props) => {
  const { refs, isOpen, nodeId, renderList } = useContextMenu({
    children: props.children,
  });

  React.useEffect(() => {
    if (!isOpen) {
      props.onClose?.();
    }
  }, [isOpen, props]);

  React.useLayoutEffect(() => {
    refs.setPositionReference({
      getBoundingClientRect() {
        return {
          width: 0,
          height: 0,
          x: props.left,
          y: props.top,
          top: props.top,
          right: props.left,
          bottom: props.top,
          left: props.left,
        };
      },
    });
  }, [props.left, props.top, refs]);

  return <FloatingNode id={nodeId}>{renderList()}</FloatingNode>;
};

export { RootMenu };
